// ============================================================
// AUTH TOGGLE — driven by REACT_APP_AUTH_ENABLED env var.
// Set REACT_APP_AUTH_ENABLED=false to bypass Azure AD (e.g. Playwright tests).
// ============================================================
export const AUTH_ENABLED = process.env.REACT_APP_AUTH_ENABLED !== 'false';
